import { render, staticRenderFns } from "./DomainHeading.vue?vue&type=template&id=1faae5db&"
import script from "./DomainHeading.vue?vue&type=script&lang=js&"
export * from "./DomainHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports